import { get } from 'lodash';

import { DecimalNumber } from '@app/shared/common/decimal-number/decimal-number';
import { IQohQtyCalculatorParams } from './calculators.types';

const qohCalculator = (params: IQohQtyCalculatorParams) => {
  const { threshold, replenishType, percent, measureFactor, additionalData } =
    params;
  const replenishQuantity: DecimalNumber = new DecimalNumber(
    get(threshold, replenishType) || 0,
  )
    .mul(percent)
    .div(100);

  // [replenishQuantity * thresholdsMeasureFactorValue]
  let replenishmentValue: DecimalNumber = replenishQuantity.mul(
    measureFactor.threshold,
  );
  // [replenishQuantity * thresholdsMeasureFactorValue - qohTo - pendingQtyTo]
  replenishmentValue = replenishmentValue.sub(additionalData.transferTo);
  // [replenishQuantity * thresholdsMeasureFactorValue - qohTo - pendingQtyTo] / selectedMeasureFactorValue
  replenishmentValue = replenishmentValue.div(measureFactor.item);

  return replenishmentValue;
};

export { qohCalculator };
